import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const navbarData = [
  { id: 1, title: "About", to: "/about" },
  { id: 2, title: "Services", to: "/services" },
  { id: 3, title: "Projects", to: "/projects" },
  { id: 4, title: "Blogs", to: "/blogs" },
  { id: 5, title: "Connect", to: "/connect" },
];

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <nav className="fixed top-0 w-full z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200 shadow-md">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo/Brand */}
          <NavLink
            to="/about"
            className="font-bold text-lg bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent hover:opacity-80 transition-opacity"
          >
            SI
          </NavLink>

          {/* Desktop nav links */}
          <div className="hidden md:flex items-center justify-center space-x-1 absolute left-1/2 transform -translate-x-1/2">
            {navbarData.map((el) => (
              <NavLink
                key={el.id}
                to={el.to}
                className="px-4 py-2 rounded-md text-sm font-medium text-gray-700 transition-colors relative group whitespace-nowrap"
                activeClassName="text-green-600"
              >
                {el.title}
                <span className="absolute bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-green-400 to-emerald-500 group-hover:w-full transition-all duration-300" />
              </NavLink>
            ))}
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100"
            aria-label="Toggle menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={mobileOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
            </svg>
          </button>
        </div>

        {/* Mobile menu */}
        {mobileOpen && (
          <div className="md:hidden pb-4 space-y-2">
            {navbarData.map((el) => (
              <NavLink
                key={el.id}
                to={el.to}
                className="block px-3 py-2 rounded-md text-gray-700 hover:bg-gray-100 hover:text-green-600 transition-colors"
                activeClassName="bg-gray-100 text-green-600"
                onClick={() => setMobileOpen(false)}
              >
                {el.title}
              </NavLink>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
